/* Highlight explicitly labelled code. */
(function () {
    const content = document.querySelector('.gh-content');

    if (!content) {
        return;
    }

    const declarationKeywords = new Set([
        'actor',
        'class',
        'enum',
        'extension',
        'protocol',
        'struct',
        'typealias',
    ]);

    Prism.hooks.add('complete', function (environment) {
        environment.element.querySelectorAll('.token.class-name').forEach(function (token) {
            let previous = token.previousSibling;

            while (previous && !previous.textContent.trim()) {
                previous = previous.previousSibling;
            }

            if (
                previous instanceof HTMLElement &&
                previous.classList.contains('keyword') &&
                declarationKeywords.has(previous.textContent.trim())
            ) {
                token.classList.add('is-declaration');
            }
        });
    });

    content.querySelectorAll('pre > code').forEach(function (code) {
        code.parentElement.classList.add('code-block');
    });
})();
